import { CheckCircle2 } from 'lucide-react';
import { Reveal } from '../components/Reveal';
import { REGISTER_URL } from '../lib/links';

const FEATURES = [
  'One-time activation — no recurring admin charges',
  'Unlocks the full Alpha One ecosystem',
  'Eligible for Direct, Level, Club A/B and Leadership income',
  '24×7 automatic withdrawals',
  'Minimum withdrawal: $25 worth of LDS Tokens',
];

export function Package() {
  return (
    <section id="activation" className="section">
      <div className="container">
        <Reveal className="section-head center">
          <span className="eyebrow" style={{ justifyContent: 'center' }}>
            Joining Package
          </span>
          <h2 className="section-title">
            One activation. <span className="accent">A world of opportunity.</span>
          </h2>
        </Reveal>

        <Reveal delay={100}>
          <div className="pkg-card">
            <span className="pkg-tag">One-Time Activation</span>
            <div className="pkg-price">
              <span className="accent">$100</span>
            </div>
            <div className="pkg-unit">in LDS Token</div>
            <ul className="pkg-list">
              {FEATURES.map((f) => (
                <li key={f}>
                  <CheckCircle2 size={18} />
                  {f}
                </li>
              ))}
            </ul>
            <a href={REGISTER_URL} className="btn btn-gold btn-block">
              Activate Your Account
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
